import ko from "knockout";

const getTooltipData = function (valueAccessor, viewModel) {
    let stringKey, data, locale, placement, selfDismiss, enable, cssClass, html;
    const templateInfo = ko.unwrap(valueAccessor());

    if (typeof templateInfo == "string") {
        stringKey = templateInfo;
        data = viewModel;
    } else if (templateInfo) {
        stringKey = templateInfo.name;
        data = templateInfo.data || viewModel;
        locale = templateInfo.locale;
        placement = templateInfo.placement;
        selfDismiss = templateInfo.selfDismiss;
        enable = templateInfo.enable;
        cssClass = templateInfo.cssClass;
        html = ko.unwrap(templateInfo.html); // to support observable
    }
    stringKey = ko.unwrap(stringKey); // to support observable

    if (
        (typeof stringKey !== "string" || !stringKey) &&
        (typeof html !== "string" || !html)
    ) {
        throw new Error(
            "Invalid tool tip name or html. name: " +
                stringKey +
                ", html: " +
                html
        );
    }

    const text =
        typeof stringKey !== "string" || !stringKey
            ? null
            : ko.i18n.renderString(stringKey, data, locale);

    valueAccessor = function () {
        return {
            data: data,
            text: text,
            placement: placement,
            selfDismiss: selfDismiss,
            enable: enable,
            cssClass: cssClass,
            html: html,
        };
    };

    return valueAccessor;
};

/**
 * Binding handler that delegates to tooltip binding handler.
 * Sample usage:
 *  data-bind = "lTooltip: {name:'activeCall.requestingHold', placement:'bottom,right', selfDismiss: false}"
 *  placement and selfDismiss are optional.
 */
ko.bindingHandlers.lTooltip = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        valueAccessor = getTooltipData(valueAccessor, viewModel);
        ko.bindingHandlers.tooltip.init(
            element,
            valueAccessor,
            allBindingsAccessor,
            viewModel
        );
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        valueAccessor = getTooltipData(valueAccessor, viewModel);
        ko.bindingHandlers.tooltip.update(
            element,
            valueAccessor,
            allBindingsAccessor,
            viewModel
        );
    },
};

export default ko.bindingHandlers.lTooltip;
